export default "__VITE_ASSET__D_wH0QVA__"